import { AnyAction } from 'redux';
import * as type from './contacts.actions';
import { Contact } from '../model/types';

type ContactsState = {
  list: Contact[];
  map: Map<string, Contact>;
};

const initialState: ContactsState = {
  list: [],
  map: new Map(),
};

const contactsReducer = (
  state: ContactsState = initialState,
  action: AnyAction
): ContactsState => {
  switch (action.type) {
    case type.CONTACTS_GET: {
      const { contacts: newContacts } = action.payload;
      const changedContacts = newContacts.filter(
        contact =>
          !state.map.has(contact._id) ||
          state.map.get(contact._id).updatedAt !== contact.updatedAt
      );

      const changedContactsIds = changedContacts.map(contact => contact._id);
      if (changedContacts.length) {
        const newList = [
          ...state.list.filter(
            contact => !changedContactsIds.includes(contact._id)
          ),
          ...changedContacts,
        ];
        return {
          ...state,
          list: newList,
          map: new Map(newList.map(contact => [contact._id, contact])),
        };
      } else return state;
    }
    case type.CONTACT_ADD: {
      const newList = [...state.list, action.payload.contact];
      return {
        ...state,
        list: newList,
        map: new Map(newList.map(contact => [contact._id, contact])),
      };
    }
    case type.CONTACT_DELETE: {
      const newList = state.list.filter(
        contact => contact._id !== action.payload.contactId
      );
      return {
        ...state,
        list: newList,
        map: new Map(newList.map(contact => [contact._id, contact])),
      };
    }
    default:
      return state;
  }
};

export default contactsReducer;
